import { FilterSingleCheckbox } from '../baseInputTypes/FilterSingleCheckbox'

type Props = {}
export const PowerDotCatDotCom = (props: Props) => {
  return (
    <FilterSingleCheckbox
      label="Power.Cat.Com"
      fieldPath="productInformation.powerDotCatDotCom"
    />
  )
}
